import React from 'react';

const CloseIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="m8 8 8 8M16 8l-8 8" />
  </svg>
);

export default CloseIcon;
